import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ImgTicketBody({ incrementedTaskId, img, tasks }) {
    const location = useLocation();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const preloadImage = (url) => {
            const img = new Image();
            img.src = url;
        }

        if (incrementedTaskId !== undefined) {
            if (tasks[incrementedTaskId].img !== null) {
                preloadImage(tasks[incrementedTaskId].img);
            }
        }

    }, [img, incrementedTaskId, tasks])

    useEffect(() => {
        setLoaded(false);
    }, [location.pathname])


    const onLoad = (e) => {
        setLoaded(true);
    }

    return (
        <div className={img === null ? "display-none" : "ticket-body-thumbnail"}>
           {/*  <div className={`ticket-body-thumbnail-placeholder${loaded ? ' hidden' : ''}`} ></div> */}
            { !loaded && <div className="ticket-body-thumbnail-placeholder"></div>}
            <img
                className={'task-img'}
                loading="lazy"
                key={img}
                src={img}
                alt="Картинка к вопросу"
                onLoad={(e) => onLoad(e)}
            />
        </div>
    );
}

export default ImgTicketBody;


